module.exports = __webpack_public_path__ + "img/milkywaycore50mm_thumb.f5c4768d.jpg";